import React from 'react';
import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';
import { sanitizeHTML } from '../../../utils/sanitizeHTML';
import { FONT_SIZE_SCALE, PrintColors, PrintIcon, PrintSettings, SegmentHeaderContainer } from './PrintElements';

const NoteContainer = styled.div<{ fontSize: keyof typeof FONT_SIZE_SCALE }>`
  width: 100%;
  padding: ${({ fontSize }) => (fontSize < 12 ? Grid._4 : Grid._5)};
  border-radius: ${PrintSettings.borderRadius};
  display: flex;
  flex-direction: column;
  gap: ${({ fontSize }) => (fontSize < 12 ? Grid._1 : Grid._2)};
  font-size: ${({ fontSize }) => FONT_SIZE_SCALE[fontSize].base};
  background-color: ${PrintColors.LightGreen} !important;
  margin-bottom: ${Grid._4};

  @media print {
    ${SegmentHeaderContainer} {
      page-break-before: avoid;
      break-before: avoid;
      break-before: avoid-page;
    }
  }

  p {
    margin: 0;
    font-size: ${({ fontSize }) => FONT_SIZE_SCALE[fontSize].body};
  }
`;

export default function Note({
  title,
  text,
  fontSize,
}: {
  title: string;
  text: string;
  fontSize: keyof typeof FONT_SIZE_SCALE;
}) {
  return (
    <NoteContainer fontSize={fontSize}>
      <SegmentHeaderContainer>
        <PrintIcon className="fas fa-sticky-note" color={PrintColors.LightGray} fontSize={fontSize} />
        <div style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: sanitizeHTML(title ?? '') }} />
      </SegmentHeaderContainer>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(text ?? '') }} />
    </NoteContainer>
  );
}
